export default __webpack_public_path__ + "static/media/add-tab.20264f89.svg";